import React from "react";

export default function TempleRakshak() {
  return (
    <>
      <style>{`

      *{
        margin:0;
        padding:0;
        box-sizing:border-box;
      }

      body{
        font-family:"Poppins",sans-serif;
        background:#f3ead7;
      }

      .temple-page{
        width:100%;
        min-height:100vh;
        background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
        color:#222;
        padding:80px 0;
      }

      .container{
        width:92%;
        max-width:1200px;
        margin:auto;
      }

      /* MAIN TITLE */

      .main-title{
        text-align:center;
        margin-bottom:70px;
      }

      .main-title h1{
        font-size:48px;
        font-weight:900;
        color:#000;
        margin-bottom:20px;
        line-height:1.1;
      }

      .main-title h2{
        font-size:36px;
        font-weight:700;
        color:#8b5a00;
        line-height:1.3;
        margin-bottom:35px;
      }

      .main-title p{
        max-width:1000px;
        margin:auto;
        font-size:20px;
        line-height:1.5;
      }

      /* SECTION */

      .section{
        margin-bottom:65px;
      }

      .section-title{
        font-size:40px;
        font-weight:800;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }
      .section-titles{
        font-size:30px;
        font-weight:600;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }

      .section p{
        font-size:20px;
        line-height:1.5;
        margin-bottom:25px;
      }

      .section ul{
        padding-left:25px;
        margin-top:20px;
      }

      .section li{
        font-size:20px;
        line-height:1;
        margin-bottom:14px;
      }

      .price{
        font-size:38px;
        font-weight:700;
        color:#c58b2a;
        margin:20px 0 25px;
      }
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
.intro-image{
  display:flex;
  justify-content:center;
  margin:40px 0 15px;
}

.intro-image img{
  width:100%;
  max-width:900px;
  border:8px solid #fff;
  border-radius:20px;
  box-shadow:
    0 12px 35px rgba(0,0,0,0.18),
    0 0 0 4px #e80707ff;
  transition:0.35s ease;
}

.intro-image img:hover{
  transform:scale(1.02);
  box-shadow:
    0 18px 45px rgba(0,0,0,0.25),
    0 0 0 4px #4a160eff;
}
.membership-box{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:35px;
  margin:35px 0;
  padding:35px;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  border-radius:22px;
  border:3px solid #d4af37;
  box-shadow:0 15px 35px rgba(0,0,0,.12);
}

.membership-btn{
  background:linear-gradient(135deg,#c58b2a,#f4c542);
  color:#fff;
  font-size:34px;
  font-weight:800;
  border:none;
  border-radius:18px;
  padding:22px 42px;
  cursor:pointer;
  transition:.35s;
  box-shadow:0 10px 25px rgba(197,139,42,.35);
  text-transform:uppercase;
}

.membership-btn:hover{
  transform:translateY(-4px) scale(1.04);
  box-shadow:0 18px 35px rgba(197,139,42,.45);
}

.payment-info{
  flex:1;
}

.payment-info h3{
  color:#8b5a00;
  font-size:24px;
  margin-bottom:18px;
}

.payment-info p{
  margin:10px 0 !important;
  font-size:20px !important;
  line-height:1.4 !important;
}

.payment-info strong{
  color:#1a2a5a;
}
.payment-row{
  display:flex;
  gap:25px;
  align-items:flex-start;
}

.payment-card{
  flex:1;
  font-size:20px;
  line-height:1.4;
}

.payment-card strong{
  color:#1a2a5a;
  font-size:21px;
}
      /* MOBILE */

@media (max-width: 768px) {
  .intro-image{
    margin:22px 0 10px;
  }

  .intro-image img{
    border:5px solid #fff;
    border-radius:14px;
    box-shadow:
      0 8px 20px rgba(0,0,0,0.18),
      0 0 0 3px #d4af37;
  }
  .temple-page{
    padding:40px 0;
  }

  .container{
    width:95%;
  }

  .main-title{
    margin-bottom:30px;
  }

  .main-title h1{
    font-size:24px;
    line-height:1.1;
    margin-bottom:12px;
  }

  .main-title h2{
    font-size:16px;
    line-height:1.2;
    margin-bottom:16px;
  }

  .main-title p{
    font-size:13px !important;
    line-height:1.4 !important;
  }

  .section{
    margin-bottom:32px;
  }

  .section-title{
    font-size:18px;
    line-height:1.2;
    margin-bottom:12px;
  }

  .section-titles{
    font-size:17px;
    line-height:1.2;
    margin-bottom:10px;
  }

  .section p{
    font-size:13px !important;
    line-height:1.4;
    margin-bottom:12px;
  }
  

  .section li{
    font-size:14px;
    line-height:1;
    margin-bottom:8px;
  }

  .section ul{
    padding-left:18px;
  }

  h4{
    font-size:14px;
    margin-bottom:8px;
  }

  .price{
    font-size:28px;
    margin:12px 0;
  }

  .section-divider{
    margin:16px auto 20px;
    gap:10px;
  }

  .section-divider span{
    font-size:16px;
  }

  .section-divider::before,
  .section-divider::after{
    height:2px;
  }
  .membership-box{
    flex-direction:column;
    text-align:center;
    padding:22px;
    gap:20px;
  }

  .membership-btn{
    width:100%;
    font-size:24px;
    padding:18px;
  }

  .payment-info h3{
    font-size:18px;
  }

  .payment-info p{
    font-size:15px !important;
  }
  .payment-row{
    flex-direction:column;
    gap:18px;
  }

  .payment-card{
    text-align:center;
    font-size:15px;
  }

  .payment-card strong{
    font-size:16px;
  }
}

      `}</style>

      <div className="temple-page">

        <div className="container">

          <div className="main-title">

  <h1>Government Relations Program</h1>
<div className="section-divider">
  <span>✦ ✦ ✦</span>
</div> 
  <h2>
    Building Constructive Relationships with Government Institutions
  </h2>

  <p>
    The Americans4Hindus Dharma Action Council (A4H DAC) recognizes the importance of maintaining professional and productive relationships with elected officials, public agencies, and governmental stakeholders.
  </p>

  <p>
    The Government Relations Program serves as a bridge between community concerns and public institutions, promoting communication, collaboration, and mutual understanding.
  </p>

</div>

{/* SECTION 1 */}

<div className="section">

  <h2 className="section-titles">
    1. Ongoing Engagement with Elected Officials and Agencies
  </h2>

  <p>
    A4H DAC maintains regular communication with government offices and public agencies to share information, discuss policy developments, and identify opportunities for collaboration on issues affecting communities.
  </p>

  <p>
    These relationships support constructive dialogue and help ensure that community perspectives remain visible within public institutions.
  </p>

</div>

{/* SECTION 2 */}

<div className="section">

  <h2 className="section-titles">
    2. Policy Roundtables and Stakeholder Meetings
  </h2>

  <p>
    A4H DAC organizes forums that bring together policymakers, subject-matter experts, community leaders, and stakeholders to discuss emerging issues and public policy challenges.
  </p>

  <p>
    These discussions foster collaboration and encourage informed decision-making through the exchange of ideas and expertise.
  </p>

</div>

{/* SECTION 3 */}

<div className="section">

  <h2 className="section-titles">
    3. Building Long-Term Institutional Relationships
  </h2>

  <p>
    Effective advocacy is built upon trust, credibility, and long-term engagement. A4H DAC works to establish lasting relationships with government leaders, policymakers, agencies, and community organizations.
  </p>

  <p>
    These partnerships strengthen the organization's ability to participate constructively in policy discussions and contribute to positive civic outcomes.
  </p>

</div>





        </div>

      </div>
    </>
  );
}